import useApi from "../..";

const useQuoteApi = () => {
    const { request } = useApi(); 
  
    const getQuotesReceivedForJobRequest = (requestId, limit, offset) => request(`/quote/${requestId}?limit=${limit}&offset=${offset}`, 'GET', null)
    const createQuote = (payload) => request('/quote', 'POST', payload)
    const getMySentQuotes = (limit, offset) => request(`/quote?limit=${limit}&offset=${offset}`, 'GET', null)
    const getQuoteDetails = (quoteId) => request(`/quote/${quoteId}/details`, 'GET', null)
    const acceptRejectQuote = (payload) => request('/quote/accept-reject', 'PATCH', payload)

    return { 
        getQuotesReceivedForJobRequest,
        createQuote,
        getMySentQuotes,
        getQuoteDetails,
        acceptRejectQuote
    };
};

export default useQuoteApi;
